/*
---
description: Lazy widget for save delete listing toggler
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.4.0: '*'
- more/1.4.0.1: [Utilities.Assets]
provides: [SaveDelete]
...
*/

var SaveDelete = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'link-icon',
		url_save: '',
		url_delete: '',
		url_signin: '',
		relayed_data: null, // delegated selector
		create_button: true
	},

	initialize: function(_scope, options){
		if (!_scope) return;

		this._scope = _scope;
		this.setOptions(options);
		this.build();
	},

	build: function(){
		var self = this;
		var opts = this.options;

		this.active_id = null;
		this.request_object = null;

		this._scope.getElements(opts.relayed_data).each(function(_el){
			if(_el.getElement('.w_savedelete') && opts.create_button) return;

			var _btn = self.create_button_for_row(_el);

			if(!_btn) return;


			var url = self.clean_url(opts.url_signin);

			if(url && url != ''){
				_btn.set({
					'class': 'w_savedelete reg_blimp _save_listing',
					'data-listing-token': _el.getAttribute('data-id')
				})

				Core.add_signup_link(_btn);
			}else{
				_btn.addEvent('click', function(e){
					self.handle_mouseclick(e, _btn);
				});
			}
		});
	},

	clean_url: function(dirty){
		if(!dirty) return;

		var first_char = dirty.substr(0, 1);
		var last_char = dirty.substr(dirty.length-1, 1);
		var clean = dirty;

		if (first_char == '#') {
			clean = clean.substr(1, clean.length-1);
		}

		if (last_char == '?') {
			clean = clean.substr(0, clean.length-1);
		}

		return clean;
	},

	create_data_object: function(source){
		var opts = this.options;
		var status;
		var id;

		switch(typeOf(source)){
			case 'element':
				status = source.getAttribute('data-savedelete-status') || "-1";
				id = source.getAttribute('data-id') || "0";
			break;
			case 'object':
			default:
				status = source.status;
				id = source.id;
			break;
		}

		if(status == '-1') return;

		var cls = null,
				rpc = '',
				data_cls = null;

		switch(status){
			case "0": // deleted
				cls = '_save';
				rpc = this.clean_url(opts.url_save);
			break;
			case "1": // saved
				cls = '_delete';
				rpc = this.clean_url(opts.url_delete);
			break;
			case "2": // not logged in
				cls = '';
				data_cls = 'w_blimp_signin';
				rpc = this.clean_url(opts.url_signin);
			break;
			case "-1":
			default: // not applicable
			break;
		}

		return {
			status: status,
			id: id,
			rpc: rpc,
			cls: cls,
			data_cls: data_cls
		};
	},

	handle_mouseclick: function(e, _el){
		e.stop();
		var data = _el.data;

		new Request.JSON({
			url: data.rpc,
			data: Object.toQueryString({
				t: data.id
			}),
			onComplete: function(response_object) {
				this.fireEvent('change', [response_object, _el]);
				_el.dispose();
			}.bind(this)
		}).get();
	},

	create_button_for_row: function(_row){
		var opts = this.options;
		var data = this.create_data_object(_row);

		if(!data) return;

		var _btn;

		if(opts.create_button){
			var _parent = _row.getElement('.links-icons') || _row;

			_btn = new Element('span.' + opts.cls, {
				'html' : '<i class="fa fa-heart-o" aria-hidden="true"></i><span class="link-label">Save</span>'
			}).inject(_parent);
		}else{
			_btn = _row.getElement('.w_savedelete');
		}

		_btn.data = data;

		if(data.cls){
			_btn.addClass(data.cls);
		}

		if(data.data_cls){
			_btn.setAttribute('data-class', data.data_cls);
		}

		_btn.store('position', _btn.getPosition());

		return _btn;
	}
});
